import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { SnackBarContext } from 'components';
import { Icon } from 'components';
import { Box, IconButton, ImageListItem, ImageListItemBar, Tooltip} from '@mui/material';
import styled from 'styled-components';
import { theme } from 'config';


export interface IChartImageItemProps {
  title:     string,
  desc?:     string,
  component: React.ReactNode,
  disabled:  boolean,
  onClick?:  React.MouseEventHandler,
}

export const ChartImageItem = observer((props: IChartImageItemProps): JSX.Element => {
  const { title, disabled, component, desc, onClick } = props;
  const { t }     = useTranslation();
  const { toast } = React.useContext(SnackBarContext);

  return (
    <ItemContainer>
      {!disabled ?
      <HoverHighlight onClick={onClick}/> : 
      <Tooltip placement='top' title={t('chart_currently_unavailable')}>
        <HoverHighlight disabled/>
      </Tooltip>
      }
      <ImageListItem>
      <Box padding={2} sx={{height: '26rem'}}>
        {component}
      </Box>
      <ImageListItemBar
        title={title}
        subtitle={desc}
      />
      </ImageListItem>
    </ItemContainer>
  );
});

const HoverHighlight = styled(Box)<{disabled?: boolean}>`
  position:         absolute;
  cursor:           ${(p) => !p.disabled && 'pointer'};
  background-color: ${(p) =>  p.disabled && 'rgba(0,0,0,0.35)'};
  width:            100%;
  height:           100%;
  top:              0;
  z-index:          2;

  :hover {
    background: ${(p) => !p.disabled && theme.palette.white.main};
    opacity:    ${(p) => p.disabled ? 1 : 0.15};
  };
`;

const ItemContainer = styled(Box)`
  position:        relative;
  width:           100%;
  height:          100%;
  background:      ${theme.palette.white.main};
`;